import styled, { css } from 'styled-components';
import { OxContainer } from 'src/components/OxContainer';
import { fluidSizing, toVw } from 'src/utils';
import { createTextStyle } from 'src/utils/createTextStyle';
import { OxImage } from 'src/components/OxImage';
import { EFonts, EFontWeight, ESizes } from 'src/config/enums';

export const List = styled(OxContainer)(
    ({ theme }) => css`
        display: grid;
        grid-template-columns: 1fr;

        ${fluidSizing([
            { prop: 'column-gap', values: [10, 10, 10] },
            { prop: 'row-gap', values: [35, 35, 35] }
        ])}

        ${theme.breakpoints.down('xs')} {
            padding-left: 0;
            padding-right: 0;
        }

        ${theme.breakpoints.only('s')} {
            grid-template-columns: 1fr 1fr;
        }

        ${theme.breakpoints.up('m')} {
            grid-template-columns: 1fr 1fr 1fr;
        }
    `
);

export const Item = styled.li`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const Text = styled.div<{ $hasImage?: boolean }>(
    ({ theme, $hasImage }) => css`
        ${fluidSizing([
            { prop: 'padding-bottom', values: [15, 15, 15] },
            { prop: 'padding-left', values: [15, 15, 15] },
            { prop: 'padding-right', values: [15, 15, 15] }
        ])}
        ${theme.breakpoints.only('xs')} {
            padding-left: ${toVw(ESizes.GutterXS, 'xs')};
            padding-right: ${toVw(ESizes.GutterXS, 'xs')};
        }

        ${!$hasImage &&
        css`
            h3 {
                ${createTextStyle(EFonts.Hatton, EFontWeight.Medium, [14, 16, 18], [18, 20, 22], true)}
            }
        `}
    `
);

export const Image = styled(OxImage)`
    margin-top: auto;
`;
